import { useEffect, useState } from "react";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from "recharts";
import api, { money } from "@/lib/api";
import AdminLayout from "@/components/admin/AdminLayout";
import { TableShell, Th, Td, EmptyRow } from "@/components/admin/DataTable";

export default function Reports() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/reports/summary").then((r) => setData(r.data)).catch(() => {}); }, []);
  if (!data) return <AdminLayout title="Reports"><p className="text-muted-foreground">Loading...</p></AdminLayout>;
  return (
    <AdminLayout title="Reports">
      <div className="grid gap-4 sm:grid-cols-3">
        <div className="rounded-xl border border-border bg-card p-5"><p className="text-xs text-muted-foreground">Total Orders</p><p className="font-display text-2xl font-extrabold">{data.total_orders}</p></div>
        <div className="rounded-xl border border-border bg-card p-5"><p className="text-xs text-muted-foreground">Total Sales</p><p className="font-display text-2xl font-extrabold">{money(data.total_sales)}</p></div>
        <div className="rounded-xl border border-border bg-card p-5"><p className="text-xs text-muted-foreground">Total Collected</p><p className="font-display text-2xl font-extrabold text-primary">{money(data.total_collected)}</p></div>
      </div>
      <div className="mt-6 rounded-xl border border-border bg-card p-5">
        <h3 className="mb-4 font-display font-semibold">Branch Performance</h3>
        <ResponsiveContainer width="100%" height={280}>
          <BarChart data={data.by_branch}>
            <CartesianGrid strokeDasharray="3 3" stroke="hsl(var(--border))" />
            <XAxis dataKey="branch" stroke="hsl(var(--muted-foreground))" fontSize={12} />
            <YAxis stroke="hsl(var(--muted-foreground))" fontSize={12} />
            <Tooltip contentStyle={{ background: "hsl(var(--card))", border: "1px solid hsl(var(--border))", borderRadius: 12 }} />
            <Bar dataKey="sales" fill="#0D9488" radius={[6, 6, 0, 0]} />
            <Bar dataKey="collected" fill="#2DD4BF" radius={[6, 6, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </div>
      <div className="mt-6">
        <TableShell>
          <thead className="border-b border-border bg-secondary/40"><tr><Th>Branch</Th><Th>Orders</Th><Th>Sales</Th><Th>Collected</Th></tr></thead>
          <tbody className="divide-y divide-border">
            {data.by_branch.length === 0 ? <EmptyRow colSpan={4} /> : data.by_branch.map((b, i) => (
              <tr key={i} className="hover:bg-secondary/30"><Td className="font-medium">{b.branch}</Td><Td>{b.orders}</Td><Td>{money(b.sales)}</Td><Td className="text-primary">{money(b.collected)}</Td></tr>
            ))}
          </tbody>
        </TableShell>
      </div>
    </AdminLayout>
  );
}
